import styled, { css } from 'styled-components'

import { Accordion } from '@/components/ui/accordion'

export const WorkingHours = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `,
)

export const WorkingHoursAccordion = styled(Accordion)<{ $isOpenStatus: boolean }>(
  ({ theme, $isOpenStatus }) => css`
    padding: ${theme.space['12']} ${theme.space['16']};
    background-color: ${$isOpenStatus ? theme.colors.green100 : theme.colors.orange100};
    border-radius: ${theme.border.radius['24']};

    [data-accordion-button] {
      gap: ${theme.space['4']};
    }

    [data-accordion-children-wrapper] {
      display: flex;
      flex-direction: column;
      gap: ${theme.space['2']};
      padding: ${theme.space['20']} ${theme.space['28']} ${theme.space['12']};
    }
  `,
)

export const ScheduleDay = styled.div(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
)
